(function () {
  'use strict';

  var host = document.currentScript;
  if (!host) return;

  var sources = {
    studio: host.dataset.jpStudioSrc || '',
    p0: host.dataset.jpP0Src || ''
  };
  var pending = Object.create(null);
  var loaded = Object.create(null);

  function load(name) {
    if (loaded[name]) return Promise.resolve();
    if (pending[name]) return pending[name];
    if (!sources[name]) return Promise.reject(new Error('Missing deferred feature source: ' + name));

    pending[name] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = sources[name];
      script.async = true;
      script.dataset.jpDeferredFeature = name;
      script.onload = function () {
        loaded[name] = true;
        resolve();
      };
      script.onerror = function () {
        delete pending[name];
        reject(new Error('Unable to load deferred feature: ' + name));
      };
      document.head.appendChild(script);
    });
    return pending[name];
  }

  function report(error, context) {
    if (window.JPRuntime && window.JPRuntime.reportError) window.JPRuntime.reportError(error, context);
    else if (window.console && window.console.error) window.console.error(error);
  }

  function replayCustomEvent(event, feature) {
    if (loaded[feature] || !sources[feature]) return;
    event.stopImmediatePropagation();
    var target = event.target || document;
    var detail = event.detail || {};
    load(feature).then(function () {
      target.dispatchEvent(new CustomEvent(event.type, { bubbles: event.bubbles, cancelable: event.cancelable, detail: detail }));
    }).catch(function (error) { report(error, 'deferred-' + feature + '-event'); });
  }

  window.JPFeatureLoader = { load: load, isLoaded: function (name) { return !!loaded[name]; } };

  document.addEventListener('justpress:open-studio', function (event) { replayCustomEvent(event, 'studio'); }, true);
  ['justpress:open-size', 'justpress:open-package-sheet', 'justpress:open-add-design', 'justpress:review-set'].forEach(function (name) {
    document.addEventListener(name, function (event) { replayCustomEvent(event, 'p0'); }, true);
  });

  var p0ClickSelector = [
    '[data-jp-p0-save]', '[data-jp-p0-add-product]', '[data-jp-p0-add-cart]', '[data-jp-p0-open-size]',
    '[data-jp-p0-cart-add]', '[data-jp-library-filter-open]', '[data-jp-library-filter-close]',
    '[data-jp-library-quick-filter]', '[data-jp-library-filter]', '[data-jp-library-search-open]', '[data-jp-library-search-cancel]',
    '[data-jp-package-open]', '[data-jp-studio-checkout]', '[data-jp-studio-b-checkout]', '[data-jp-current-set-open]',
    '[data-jp-p0-design-open]', '[data-jp-studio-b-item]'
  ].join(',');

  function replayTarget(trigger) {
    /* Studio rails are re-rendered with innerHTML on every state change, and
       initializing p0 can write state. If the clicked card was replaced while
       p0 loaded, replay on its live twin (same design id, same container kind). */
    if (!trigger || trigger.isConnected) return trigger;
    var id = trigger.getAttribute('data-jp-p0-design-open') || trigger.getAttribute('data-jp-studio-b-item');
    if (!id || !window.CSS || typeof window.CSS.escape !== 'function') return null;
    var inManage = trigger.hasAttribute('data-jp-studio-manage-item');
    var selector = '[data-jp-p0-design-open="' + window.CSS.escape(id) + '"]' + (inManage ? '[data-jp-studio-manage-item]' : ':not([data-jp-studio-manage-item])');
    return document.querySelector(selector);
  }

  document.addEventListener('pointerdown', function (event) {
    if (sources.studio && event.target.closest('[data-jp-entry-upload]')) load('studio').catch(function (error) { report(error, 'deferred-studio-pointer'); });
    if (sources.p0 && event.target.closest(p0ClickSelector)) load('p0').catch(function (error) { report(error, 'deferred-p0-pointer'); });
  }, true);

  document.addEventListener('focusin', function (event) {
    if (sources.p0 && event.target.matches('[data-jp-p0-search]')) load('p0').catch(function (error) { report(error, 'deferred-p0-search'); });
  }, true);

  document.addEventListener('click', function (event) {
    if (!sources.p0 || loaded.p0) return;
    var trigger = event.target.closest(p0ClickSelector);
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    load('p0').then(function () {
      var target = replayTarget(trigger);
      if (target) target.click();
    }).catch(function (error) { report(error, 'deferred-p0-click'); });
  }, true);

  var params = new URLSearchParams(window.location.search);
  if (sources.studio && (params.get('mode') || params.get('item'))) load('studio').catch(function (error) { report(error, 'deferred-studio-deep-link'); });
  if (sources.p0 && (params.get('panel') || params.get('jp_resume_checkout') === '1' || params.get('q'))) load('p0').catch(function (error) { report(error, 'deferred-p0-deep-link'); });
})();
